module.exports = __webpack_public_path__ + "img/16.eaa79be6.jpg";